<template>
    <div id="household-calories" class="mt-6 mb-8">
        <h3 class="text-lg font-semibold mb-4 text-center">
            Détail des apports caloriques du foyer
        </h3>

        <table class="min-w-full border border-gray-400 text-sm table-fixed">
            <!-- Ligne : titres -->
            <thead class="bg-gray-100">
                <tr>
                    <th class="border px-3 py-2 w-40 text-left">Membre du foyer</th>
                    <th v-for="m in data.members" :key="m.name" class="border px-3 py-2 text-center">
                        {{ m.name }}
                    </th>
                </tr>
            </thead>

            <!-- Ligne : Besoin calorique -->
            <tbody>
                <tr>
                    <td class="border px-3 py-2 font-semibold">
                        Besoin calorique journalier (en calories)
                    </td>

                    <td v-for="m in data.members" :key="m.name + '_kcal'" class="border px-3 py-2 text-center">
                        {{ m.kcal }}
                    </td>
                </tr>

                <!-- Ligne : Proportion du foyer -->
                <tr>
                    <td class="border px-3 py-2 font-semibold">
                        En proportion du foyer
                    </td>

                    <td v-for="m in data.members" :key="m.name + '_pct'" class="border px-3 py-2 text-center">
                        {{ m.percent }}%
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: "NutritionApports",
    props: {
        data: Object, // { total: 6651, members: [...] }
    },
};
</script>

<style scoped>
table {
    border-collapse: collapse;
}

th,
td {
    border: 1px solid #333;
}
</style>
